import { render, staticRenderFns } from "./traders-list.vue?vue&type=template&id=7fe6169f&"
import script from "./traders-list.vue?vue&type=script&lang=js&"
export * from "./traders-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports